import Core from '@plugin_productlist/core';

export default Core;
